import '@/lib/helpers';
import {
  ActionIcon,
  Box,
  Flex,
  Group,
  Paper,
  SegmentedControl,
  Text,
  Textarea,
  Tooltip,
} from '@mantine/core';
import { marked } from 'marked';
import { useState } from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

export default function DisclaimerSection({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const [render, setRender] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Paper
      p="xs"
      mb="xs"
      withBorder
      styles={{
        root: {
          background:
            'light-dark(var(--mantine-color-white), var(--mantine-color-dark-6))',
          borderRadius: '5px',
          boxShadow:
            'light-dark(0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.4))',
        },
      }}
    >
      <Flex justify="space-between" align="center">
        <Group gap={0}>
          <Text size="xs" fw={500} pl={0}>
            Disclaimer
          </Text>
        </Group>
        <Group gap={2}>
          {!isCollapsed && (
            <SegmentedControl
              size="xs"
              value={render ? 'preview' : 'edit'}
              onChange={(value) => setRender(value === 'preview')}
              p={1}
              data={[
                { label: 'Edit', value: 'edit' },
                { label: 'Preview', value: 'preview' },
              ]}
            />
          )}
          <Tooltip label={isCollapsed ? 'Expand block' : 'Collapse block'}>
            <ActionIcon
              variant="subtle"
              color="gray"
              onClick={() => setIsCollapsed(!isCollapsed)}
            >
              {isCollapsed ? (
                <BiChevronUp size={16} />
              ) : (
                <BiChevronDown size={16} />
              )}
            </ActionIcon>
          </Tooltip>
        </Group>
      </Flex>
      {!isCollapsed && (
        <Box mt={'xs'}>
          {render ? (
            <div
              className="md"
              style={{
                padding: 'var(--mantine-spacing-xs)',
                border: '1px solid transparent',
                borderRadius: 'var(--mantine-radius-sm)',
              }}
              dangerouslySetInnerHTML={{
                __html: marked(value, { breaks: true }),
              }}
            />
          ) : (
            <Textarea
              size="xs"
              autosize
              minRows={6}
              value={value}
              onChange={(e) => onChange(e.target.value)}
            />
          )}
        </Box>
      )}
    </Paper>
  );
}
